import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  GET_COUNTRY_FAILURE,
  GET_COUNTRY_REQUEST,
  GET_COUNTRY_SUCCESS,
  GET_STATE_FAILURE,
  GET_STATE_REQUEST,
  GET_STATE_SUCCESS,
  GET_CITY_FAILURE,
  GET_CITY_REQUEST,
  GET_CITY_SUCCESS,
} from "./customerAddressTypes";

const initialState = {
  viewAllCountry: { ...defaultStatus },
  viewAllState: { ...defaultStatus },
  viewAllCity: { ...defaultStatus },
};

const CustomerAddressReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // Get all countries
    case GET_COUNTRY_REQUEST:
      return {
        ...state,
        viewAllCountry: { ...defaultStatus, inProgress: true, ...payload },
      };
    case GET_COUNTRY_SUCCESS:
      return {
        ...state,
        viewAllCountry: { ...defaultStatus, success: true, ...payload },
      };
    case GET_COUNTRY_FAILURE:
      return {
        ...state,
        viewAllCountry: { ...defaultStatus, error: true, ...payload },
      };

    // Get all states
    case GET_STATE_REQUEST:
      return {
        ...state,
        viewAllState: { ...defaultStatus, inProgress: true, ...payload },
      };
    case GET_STATE_SUCCESS:
      return {
        ...state,
        viewAllState: { ...defaultStatus, success: true, ...payload },
      };
    case GET_STATE_FAILURE:
      return {
        ...state,
        viewAllState: { ...defaultStatus, error: true, ...payload },
      };

    // Get all cities
    case GET_CITY_REQUEST:
      return {
        ...state,
        viewAllCity: { ...defaultStatus, inProgress: true, ...payload },
      };
    case GET_CITY_SUCCESS:
      return {
        ...state,
        viewAllCity: { ...defaultStatus, success: true, ...payload },
      };
    case GET_CITY_FAILURE:
      return {
        ...state,
        viewAllCity: { ...defaultStatus, error: true, ...payload },
      };

    default:
      return state;
  }
};

export default CustomerAddressReducer;
